import { Job, JobStatus } from '@core/generated/gql-types';
import type { JobDrawerWorkerSection } from '@/modules/jobs/views/jobDrawer.view';
import AssignedWorker from './workerSelection/assignedWorker/AssignedWorker';
import SelectWorker from './workerSelection/SelectWorker';

interface WorkerSectionProps {
  job: Job;
  mode?: JobDrawerWorkerSection;
  allowUnassignWorker?: boolean;
  showWorkerPayRate?: boolean;
}

const WorkerSection = ({
  job,
  mode = 'assign',
  allowUnassignWorker = true,
  showWorkerPayRate = true,
}: WorkerSectionProps) => {
  if (job.itemStatus === JobStatus.Cancelled) {
    if (!job.userId) {
      return null;
    }

    return (
      <AssignedWorker
        job={job}
        allowUnassign={false}
        showWorkerPayRate={showWorkerPayRate}
      />
    );
  }

  switch (mode) {
    case 'none':
      return null;
    case 'viewAndAssignJobApplicantsOnly':
      if (!job.userId) {
        return (
          <SelectWorker
            job={job}
            showAllApplicants={false}
            showWorkerPayRate={showWorkerPayRate}
          />
        );
      }
      return (
        <AssignedWorker
          job={job}
          allowUnassign={allowUnassignWorker}
          showWorkerPayRate={showWorkerPayRate}
        />
      );
    case 'assign':
    default:
      if (job.userId) {
        return (
          <AssignedWorker
            job={job}
            allowUnassign={allowUnassignWorker}
            showWorkerPayRate={showWorkerPayRate}
          />
        );
      }
      return (
        <SelectWorker job={job} showWorkerPayRate={showWorkerPayRate} />
      );
  }
};

export default WorkerSection;
